
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"64","height":"64","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","stroke":"#D6DBEA","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2.102"}},[_c('path',{attrs:{"d":"M8.33 52.143h48.34M8.33 35.329l21.017-8.407M12.534 33.688v18.455M26.195 12.21L56.67 31.126M52.466 28.564v23.579M46.161 24.625v-7.16c0-.58.47-1.051 1.051-1.051h2.102c.58 0 1.05.47 1.05 1.05v9.755M47.212 52.143c.58 0 1.05-.47 1.05-1.051v-6.305c0-.58-.47-1.051-1.05-1.051h-12.61c-.58 0-1.051.47-1.051 1.05v6.306c0 .58.47 1.05 1.05 1.05M41.958 43.736v8.407M35.655 31.126a3.153 3.153 0 106.305 0 3.153 3.153 0 00-6.305 0h0zM24.093 52.143c.58 0 1.051-.47 1.051-1.051v-8.407c0-.58-.47-1.05-1.05-1.05h-6.306c-.58 0-1.05.47-1.05 1.05v8.407c0 .58.47 1.05 1.05 1.05M29.347 14.213v37.93"}})])])
          )
        }
      }
    